/* Step 11d-1 (owner decisions of 01-Nov-2026 on #115 / #116 / #117) — EN + AR.
   A1: the allowance kind on the platform key ("contact Customer Service"; backend/ai_error_text.py TEXT, same words).
   A2 / A5: errors.<CODE> of coded job failures (lib/jobErrorText.js reads error_ar first, then these).
   A11: who may restore from the Recycle Bin. A12: the cost warning in the pre-mark confirm dialog.
   No provider name in any text here (CLAUDE.md §3). */
export default {
  en: {
    aiErr: {
      allowance_platform: "AI allowance used up — contact Customer Service.",
    },
    errors: {
      AI_ALLOWANCE_USED_UP_PLATFORM: "AI allowance used up — contact Customer Service.",
      GL_COMMIT_STAGING_INCOMPLETE: "The uploaded rows expired (over 24 hours) — upload the file again. Nothing was saved.",
    },
    risk: {
      bin: {
        restoreWho: "Who may restore: any firm role. Team members restore the items of the engagements they are on; a Partner or "
          + "Firm Admin restores any item. Restoring a deleted engagement needs a Partner or Firm Admin and a fresh two-factor code.",
        restoreForbidden: "Your account cannot restore from this firm's Recycle Bin. Any firm role may restore — ask a member of "
          + "the engagement team, a Partner or a Firm Admin.",
      },
    },
    dc: {
      pre: { cont: "Confirm and start" },
    },
    dcCost: {
      basisHistory: "{b} batches × {per} units per batch — the average of {n} batches of your firm's past pre-mark runs",
      basisStandard: "standard estimate from the size of the batches — your firm has no past pre-mark run yet",
      cost: "Estimated cost",
      remaining: "Your firm's remaining AI allotment",
      remainingOf: "{r} of {a} units",
      noKey: "no AI allotment issued to your firm",
      over: "This run needs about {u} units — more than the {r} units your firm has left. It stops when the allotment is used up; "
        + "the batches finished by then are kept.",
      confirmNote: "Nothing runs until you confirm with the button below.",
    },
  },
  ar: {
    aiErr: {
      allowance_platform: "نفدت حصة الذكاء الاصطناعي — يرجى التواصل مع خدمة العملاء.",
    },
    errors: {
      AI_ALLOWANCE_USED_UP_PLATFORM: "نفدت حصة الذكاء الاصطناعي — يرجى التواصل مع خدمة العملاء.",
      GL_COMMIT_STAGING_INCOMPLETE: "انتهت صلاحية الصفوف المرفوعة (أكثر من 24 ساعة) — ارفع الملف مرة أخرى. لم يُحفظ شيء.",
    },
    risk: {
      bin: {
        restoreWho: "من يمكنه الاستعادة: أي دور في المكتب. يستعيد أعضاء الفريق عناصر المهام التي هم أعضاء فيها؛ ويستعيد الشريك أو "
          + "مسؤول المكتب أي عنصر. تتطلب استعادة مهمة محذوفة شريكًا أو مسؤول المكتب ورمز تحقق ثنائي جديدًا.",
        restoreForbidden: "لا يمكن لحسابك الاستعادة من سلة محذوفات هذا المكتب. يمكن لأي دور في المكتب الاستعادة — اطلب ذلك من أحد "
          + "أعضاء فريق المهمة أو الشريك أو مسؤول المكتب.",
      },
    },
    dc: {
      pre: { cont: "تأكيد وبدء التشغيل" },
    },
    dcCost: {
      basisHistory: "{b} دفعة × {per} وحدة لكل دفعة — متوسط {n} دفعة من تشغيلات التأشير المسبق السابقة لمكتبكم",
      basisStandard: "تقدير قياسي من حجم الدفعات — لا يوجد لمكتبكم تشغيل تأشير مسبق سابق بعد",
      cost: "التكلفة المقدَّرة",
      remaining: "المتبقي من حصة الذكاء الاصطناعي لمكتبكم",
      remainingOf: "{r} من {a} وحدة",
      noKey: "لم تُصدر حصة ذكاء اصطناعي لمكتبكم",
      over: "يحتاج هذا التشغيل إلى نحو {u} وحدة — أكثر من {r} وحدة متبقية لمكتبكم. يتوقف عند نفاد الحصة؛ وتُحفظ الدفعات المنتهية حتى ذلك الحين.",
      confirmNote: "لا يبدأ أي تشغيل قبل التأكيد بالزر أدناه.",
    },
  },
};
